import { useQuery } from "react-query";
import {
  getPreOrderDatesAPI,
  getPreOrderHoursAPI,
} from "Requests/SchedulePartners";

interface UseGetCalendarsProps {
  dateRequest: string;
  zipcode: string;
  query_date: string;
  appointmentId: number | null;
  clientId: number;
  preOrderId: number;
}

export const useGetAppointment = ({
  dateRequest,
  zipcode = "",
  appointmentId,
  query_date,
  clientId,
  preOrderId,
}: UseGetCalendarsProps) => {
  const scheduleParams = {
    cep: zipcode,
    appointmentType: appointmentId,
    clientId,
    preOrderId,
  };

  const availableDates = useQuery({
    queryKey: ["available-dates", dateRequest],
    queryFn: () =>
      getPreOrderDatesAPI({
        ...scheduleParams,
        month: dateRequest,
      }),
    refetchOnWindowFocus: false,
    // enabled: !!appointmentId,
    retry: 1,
    select: (data) => {
      const arr: any = [];
      data.forEach((date) => {
        const newDate = new Date(`${date.date}T03:00:00`);
        arr.push({
          date: newDate.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
          }),
          day: newDate.toLocaleDateString("pt-BR", { weekday: "long" }),
          query: date.date,
        });
      });

      return arr;
    },
  });

  const availableHours = useQuery({
    queryKey: ["available-hours", dateRequest, query_date],
    queryFn: () => getPreOrderHoursAPI({ ...scheduleParams, date: query_date }),
    refetchOnWindowFocus: false,
    enabled: !!query_date,
  });

  return {
    availableDates,
    availableHours,
  };
};
